import { render, staticRenderFns } from "./alternative-mechanics.vue?vue&type=template&id=5c2a4c62&scoped=true"
import script from "./alternative-mechanics.vue?vue&type=script&lang=js"
export * from "./alternative-mechanics.vue?vue&type=script&lang=js"
import style0 from "./alternative-mechanics.vue?vue&type=style&index=0&id=5c2a4c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2a4c62",
  null
  
)

export default component.exports